import { render, staticRenderFns } from "./integralGetList.vue?vue&type=template&id=19f6caf6&scoped=true"
import script from "./integralGetList.vue?vue&type=script&lang=js"
export * from "./integralGetList.vue?vue&type=script&lang=js"
import style0 from "./integralGetList.vue?vue&type=style&index=0&id=19f6caf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f6caf6",
  null
  
)

export default component.exports